import React from 'react';

const SidebarContentWrapper: React.FC = ({ children }) => {
	return <div>{children}</div>;
};

export default SidebarContentWrapper;
